import React from 'react';
import { answerBlocks, inlineParts } from '@/lib/answerText';

/** Le parole tra `**` in grassetto, dentro una riga qualsiasi. */
export const InlineText = ({ text }: { text: string }) => (
  <>
    {inlineParts(text).map((part, index) =>
      part.strong ? (
        <strong key={index} className="font-semibold text-ink">
          {part.text}
        </strong>
      ) : (
        <React.Fragment key={index}>{part.text}</React.Fragment>
      )
    )}
  </>
);

/**
 * Una risposta delle FAQ, a paragrafi ed elenchi: una riga del testo è un
 * paragrafo, le righe che iniziano con «- » sono un elenco, le parole tra
 * `**` vanno in grassetto (vedi `lib/answerText`). Eredita dimensione e
 * colore da chi la contiene.
 */
const AnswerText = ({ text }: { text: string }) => (
  <>
    {answerBlocks(text).map((block, index) =>
      block.kind === 'p' ? (
        <p key={index} className="mt-2.5 first:mt-0">
          <InlineText text={block.text} />
        </p>
      ) : (
        <ul key={index} className="mt-2 list-disc space-y-1 pl-5 marker:text-ink-subtle first:mt-0">
          {block.items.map(item => (
            <li key={item}>
              <InlineText text={item} />
            </li>
          ))}
        </ul>
      )
    )}
  </>
);

export default AnswerText;
